import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classNames from "classnames";
import Slider from "react-slick";

import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../../Text";

import {
  getCollectionList,
  getImageBanner,
  getCollectionProductBrands,
  getCollectionBrands
} from "../../../actions/kafairAction";
import { doChangeCategory } from "../../../actions/categoryAction";

import { normalizeBrand } from "../../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../../utils";

import FanImg from "../../../images/kipas.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const previewBrands = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 10,
  slidesToScroll: 10,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
};

class LocalBrandsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "sneakers",
      page: 1
    };
  }

  componentDidMount() {
    const payloadProducts = {
      collection: "local-brands",
      collection_type: "brands",
      page: 1,
      per_page: 16
    };

    const payloadBrands = {
      page: 1,
      per_page: 30
    };

    this.props.getImageBanner("local-brands", "local_brands");
    this.props.getCollectionProductBrands(payloadProducts, "local_brands");
    this.props.getCollectionBrands(payloadBrands, "local-brands");
  }

  goToProductList = slug => {
    this.props.history.push(`/kafair/${slug}`);
  };

  renderProducts = () => {
    const {
      data: {
        products: { data }
      }
    } = this.props;

    return (
      <div>
        {data.length > 0 ? (
          <Thumbnails
            settings={previewSettings}
            afterChange={this.changeImage}
            beforeChange={this._handleBeforeChange}
            thumbnails={data.map(item => {
              const category = item.product.category.name;
              return {
                id: item.id,
                slug: item.slug,
                img: item.product_variant_images.length
                  ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                  : emptyImage(category),
                display_name: item.display_name,
                brand:
                  item.product &&
                  item.product.brand &&
                  item.product.brand.flat[0],
                price: item.price,
                out_of_stock: item.out_of_stock,
                category
              };
            })}
            active={this.state.currentIndex}
            renderItems={data => this._renderItems(data)}
          />
        ) : null}
      </div>
    );
  };

  _renderItems(data) {
    return data.map((item, index) => {
      const category =
        item.category === "apparels" ? "apparel" : item.category;

      return (
        <a
          href={`/${category}/${item.id}/${item.slug}`}
          title={item.display_name}
          key={index}
          className="sneaker-item"
        >
          <div
            className={classNames("product-card", {
              disabled: !item.price || item.out_of_stock
            })}
          >
            <div
              className={classNames("sneaker-item__text", {
                disabled: !item.price || item.out_of_stock
              })}
            >
              <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
              <p>{item.display_name}</p>
            </div>
            <KickImage
              alt={item.display_name}
              src={item.img}
              className={classNames("sneaker-item__image", {
                disabled: !item.price || item.out_of_stock
              })}
            />
            {item.price ? (
              <TextRupiah
                value={item.price}
                className="price-tag"
                color="black"
                bold={true}
                align="center"
              />
            ) : (
              <span className="text-center">X</span>
            )}
          </div>
        </a>
      );
    });
  }

  goToProductList = () => {
    const {
      data: { slug }
    } = this.props;

    this.props.history.push(`/kafair/indonesian-brands`);
  };

  goToSearch = item => {
    const brand_name = item.slug
      ? item.slug.toLowerCase().replace(/\-/g, "+")
      : "";
    const newCategory =
      item.category_name === "apparels" ? "apparel" : item.category_name;

    this.props.doChangeCategory(item.category_name);

    this.props.history.push({
      pathname: `/search/${newCategory}/${brand_name}`,
      search: `brands=${item.id}&pre_verified=true`
    });
  };

  renderBrands = () => {
    const {
      data: {
        brands: { data }
      }
    } = this.props;

    if (data.length === 0) return 0;

    return (
      <Row className="row-brands">
        <Slider {...previewBrands}>
          {data.map((item, index) => {
            return (
              <div
                className="brands-title"
                onClick={() => this.goToSearch(item)}
                style={{ width: "30%" }}
              >
                <span>{item.name}</span>
              </div>
            );
          })}
        </Slider>
      </Row>
    );
  };

  render() {
    const { category } = this.state;
    const {
      data: {
        title,
        isActive,
        kafair: { imagesLandscape }
      }
    } = this.props;

    if (!isActive) return null;

    return (
      <Container fluid className="special-deals-section">
        <KickImage src={imagesLandscape} className="img-background local-brands" />
        <Row className="content-container local-brands">
          <Col md={12} xs={12}>
            <div className="left-side">
              <span className="title local-brands">{title}</span>
              <Row>
                <Col>
                  <div
                    className="see-all d-none d-sm-block"
                    onClick={this.goToProductList}
                  >
                    <span>LIHAT SEMUA</span>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={12} xs={12}>
            <div className="right-side local-brands">
              {this.renderProducts()}
              <div
                className="see-all d-block d-sm-none"
                onClick={this.goToProductList}
              >
                <span>LIHAT SEMUA</span>
              </div>
            </div>
          </Col>
        </Row>
        {this.renderBrands()}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair.local_brands
});

const mapDispatchToProps = dispatch => ({
  // getCollectionList: (category, slug, payload, name) => dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name)),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
  doChangeCategory: category => dispatch(doChangeCategory(category))
});

export default connect(mapStateToProps, mapDispatchToProps)(LocalBrandsSection);
